import "./AboutStyle.css";
export default function About() {
  return (
    <div className="about">
      <img src={`${process.env.PUBLIC_URL}/img/laptop.png`} alt="lap" />
      <p>
        I am a software engineer working in fintech, where I maintain
        and develop banking software. I handle projects independently
        and integrate systems through REST and SOAP API requests. I
        have been programming for over 7 years, building applications
        in C++ (MFC), C# and React, and I am also comfortable with SQL,
        HTML&CSS as well as JavaScript - jQuery and Ajax. Currently
        working in a fintech company.
      </p>
      <div className="sameLine">
        <h2>Technologies</h2><h1>|</h1>
        <div className="first">
          <img src={`${process.env.PUBLIC_URL}/img/cPlus.png`} alt="C++" />
          <img src={`${process.env.PUBLIC_URL}/img/cSharp.png`} alt="C#" />
        </div>
        <div className="second">
          <img src={`${process.env.PUBLIC_URL}/img/html.png`} alt="Html" />
          <img src={`${process.env.PUBLIC_URL}/img/css.png`} alt="Css" />
        </div>
        <div className="third">
          <img src={`${process.env.PUBLIC_URL}/img/react.png`} alt="React" />
          <img src={`${process.env.PUBLIC_URL}/img/javaScript.jpg`}alt="JavaScript"/>
        </div>
      </div>
    </div>
  );
}
